import styled, { css } from 'styled-components';

import { List } from 'components/list';
import { InfoCard } from 'components/info-card';

export const Container = styled.div`
  width: ${({ theme }) => (theme.responsive.isMobile ? '75vw' : '332px')};
`;

export const StyledList = styled(List)`
  height: unset;
`;

export const TotalContainer = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  ${({ theme }) =>
    theme.responsive.isMobile &&
    css`
      overflow-y: auto;
      min-height: 88px;
    `}
`;

export const StyledInfoCard = styled(InfoCard)`
  width: 100%;
  min-width: 128px;
`;
